'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var XY_POSITION_CHANGED = exports.XY_POSITION_CHANGED = 'XY_POSITION_CHANGED';


//////////////////
// WEBPACK FOOTER
// ./~/griddle-react/dist/module/plugins/position/constants/index.js
// module id = 1138
// module chunks = 0